import * as React from "react";
import { Box, Button, TextField } from "../../components/mui";
import { LockClockRoundedIcon, SaveRoundedIcon } from "../../components/icons";

import PageLayout from "../../components/shared/PageLayout";
import PageHeader from "../../components/shared/PageHeader";
import { useToast } from "../../components/shared/ToastProvider";

import "../../styles/pages/lockPeriod.css";

/**
 * Payment Lock Period Setting Page Component
 * UI/Layout only - Backend developer will add:
 * - API calls for fetching current lock period settings
 * - API calls for saving lock period settings
 */
export default function LockPeriod({ onLogout, onNavigate }) {
  const { showToast } = useToast();
  
  // Hardcoded initial values - Backend developer will replace with API calls
  const [fromDay, setFromDay] = React.useState("");
  const [toDay, setToDay] = React.useState("");
  const [errors, setErrors] = React.useState({ from: false, to: false });

  const handleSave = () => {
    // Validate inputs
    const newErrors = {
      from: fromDay === "" || fromDay === null,
      to: toDay === "" || toDay === null
    };

    setErrors(newErrors);

    // Check if there are any errors
    if (newErrors.from || newErrors.to) {
      showToast({ 
        message: "Please fill in all required fields", 
        severity: "error" 
      });
      return;
    }

    // Placeholder for future integration
    // Backend developer will implement API call to save settings
    console.log("Saving lock period:", { fromDay, toDay });
    
    showToast({ 
      message: "Lock period settings saved successfully", 
      severity: "success" 
    });
  };

  const handleFromChange = (event) => {
    const value = event.target.value;
    // Allow only numbers
    if (value === "" || /^\d+$/.test(value)) {
      setFromDay(value === "" ? "" : parseInt(value, 10));
      // Clear error when user starts typing
      if (errors.from) {
        setErrors({ ...errors, from: false });
      }
    }
  };

  const handleToChange = (event) => {
    const value = event.target.value;
    // Allow only numbers
    if (value === "" || /^\d+$/.test(value)) {
      setToDay(value === "" ? "" : parseInt(value, 10));
      // Clear error when user starts typing
      if (errors.to) {
        setErrors({ ...errors, to: false });
      }
    }
  };

  return (
    <PageLayout activeKey="lock-period" onLogout={onLogout} onNavigate={onNavigate} className="page-content">
      <PageHeader
        icon={LockClockRoundedIcon}
        title="Payment Lock Period Setting"
        summary="Configure the lock period for payment processing."
      />

      <Box className="content-box lock-period-container">
        <Box className="lock-period-form">
          <TextField
            type="number"
            size="small"
            label="From"
            required
            value={fromDay}
            onChange={handleFromChange}
            error={errors.from}
            helperText={errors.from ? "This field is required" : null}
            inputProps={{
              min: 0,
              max: 31
            }}
            className="lock-period-field"
          />

          <TextField
            type="number"
            size="small"
            label="To"
            required
            value={toDay}
            onChange={handleToChange}
            error={errors.to}
            helperText={errors.to ? "This field is required" : null}
            inputProps={{
              min: 0,
              max: 31
            }}
            className="lock-period-field"
          />

          <Box className="lock-period-actions">
            <Button variant="contained" startIcon={<SaveRoundedIcon />} onClick={handleSave}>
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </PageLayout>
  );
}
